let localAreaData = {
  areaData: {},
    init: async function() {
        const p1 = new Promise((resolve) => 
        this.getAPIData()
            .then( (data) => {
                this.areaData = data.data;
                resolve(true);
        }));
        await p1;
    },
    getAPIData: async function () {
        try {
          const localAreaId = document.querySelector('.local-area-id').value;
          const developmentId = document.querySelector('.development-id').value;
          let response = await fetch(`${APIPrefix.get()}/search_api/localareas?componentDataSourceId=${localAreaId}&pageId=${developmentId}`);
          if (response.status === 200) {
            let data = await response.json();
            return data;
          } else {
            throw new Error(response.status);
          }
        } catch (error) {
          console.log(error);
        }
    },
    get: function () {
        return this.areaData;
    }
};